import React from 'react';
import UserPanel from './MyAccountNavbar';
import { Outlet } from 'react-router-dom';

export default function MyAccount() {
    return (
        <div className={'margin flex flex-col gap-5 py-10 lg:flex-row lg:gap-20'}>
            <UserPanel />
            <div className={'min-h-[calc(100vh-500px)] w-full'}>
                <Outlet />
            </div>
        </div>
    );
}
